import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { CategoriesProvider } from './context/CategoriesContext';
import { HomeProvider } from './context/HomeContext';
import { ProductsProvider } from './context/ProductsContext';
import { CartProvider } from './context/CartContext';
import { WishlistProvider } from './context/WishlistContext';
import ProtectedRoute from './components/ProtectedRoute';
import Preloader from './components/Preloader';
import ScrollToTop from './components/ScrollToTop';

// Import Pages
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import LoginPage from './pages/LoginPage';
import ShopPage from './pages/ShopPage';
import InSeasonPage from './pages/InSeasonPage';
import FreshProducePage from './pages/FreshProducePage';
import ProductDetailPage from './pages/ProductDetailPage';
import CartPage from './pages/CartPage';
import CheckoutPage from './pages/CheckoutPage';
import WishlistPage from './pages/WishlistPage';
import ComparePage from './pages/ComparePage';
import MyAccountPage from './pages/MyAccountPage';
import ChatPage from './pages/ChatPage';
import NotFoundPage from './pages/NotFoundPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ShippingRefund from './pages/ShippingRefund';

// New Pages
import AwaitPaymentsPage from './pages/AwaitPaymentsPage';
import FlutterwaveCallbackPage from './pages/FlutterwaveCallbackPage';
import HelpPage from './pages/HelpPage';
import InstamojoCallbackPage from './pages/InstamojoCallbackPage';
import OrderDetailPage from './pages/OrderDetailPage';
import OrderPage from './pages/OrderPage';
import PaytmCallbackPage from './pages/PaytmCallbackPage';
import SettingsPage from './pages/SettingsPage';

function App() {
  return (
    <PayPalScriptProvider deferLoading={true}>
      <AuthProvider>
        <ToastProvider>
          <CategoriesProvider>
            <HomeProvider>
              <Preloader />
              <ProductsProvider>
                <CartProvider>
                  <WishlistProvider>
                    <Router>
                      <ScrollToTop />
                      <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/about" element={<AboutPage />} />
                        <Route path="/contact" element={<ContactPage />} />
                        <Route path="/faq" element={<FAQPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/shop" element={<ShopPage />} />
                        <Route path="/inseason" element={<InSeasonPage />} />
                        <Route path="/freshproduce" element={<FreshProducePage />} />
                        <Route path="/shop-grid" element={<ShopPage />} />
                        <Route path="/shop-list" element={<ShopPage />} />
                        <Route path="/shop-grid-list" element={<ShopPage />} />
                        <Route path="/product/:id" element={<ProductDetailPage />} />
                        <Route path="/product-detail" element={<ProductDetailPage />} />
                        <Route path="/product-video" element={<ProductDetailPage />} />
                        <Route path="/cart" element={<CartPage />} />
                        <Route path="/checkout" element={
                          <ProtectedRoute>
                            <CheckoutPage />
                          </ProtectedRoute>
                        } />
                        <Route path="/wishlist" element={<WishlistPage />} />
                        <Route path="/compare" element={<ComparePage />} />
                        <Route path="/chat" element={
                          <ProtectedRoute>
                            <ChatPage />
                          </ProtectedRoute>
                        } />
                        <Route path="/my-account" element={
                          <ProtectedRoute>
                            <MyAccountPage />
                          </ProtectedRoute>
                        } />
                        <Route path="/my-account-2" element={
                          <ProtectedRoute>
                            <MyAccountPage />
                          </ProtectedRoute>
                        } />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/shipping" element={<ShippingRefund />} />
                        
                        {/* New Pages */}
                        <Route path="/await-payments" element={
                          <ProtectedRoute>
                            <AwaitPaymentsPage />
                          </ProtectedRoute>
                        } />
                        <Route path="/flutterwave-callback" element={<FlutterwaveCallbackPage />} />
                        <Route path="/help" element={<HelpPage />} />
                        <Route path="/instamojo-callback" element={<InstamojoCallbackPage />} />
                        <Route path="/order/:orderId" element={
                          <ProtectedRoute>
                            <OrderDetailPage />
                          </ProtectedRoute>
                        } />
                        <Route path="/order-detail/:orderId" element={
                          <ProtectedRoute>
                            <OrderDetailPage />
                          </ProtectedRoute>
                        } />
                        <Route path="/orders" element={
                          <ProtectedRoute>
                            <OrderPage />
                          </ProtectedRoute>
                        } />
                        <Route path="/paytm-callback" element={<PaytmCallbackPage />} />
                        <Route path="/settings" element={
                          <ProtectedRoute>
                            <SettingsPage />
                          </ProtectedRoute>
                        } />
                        
                        <Route path="*" element={<NotFoundPage />} />
                      </Routes>
                    </Router>
                  </WishlistProvider>
                </CartProvider>
              </ProductsProvider>
            </HomeProvider>
          </CategoriesProvider>
        </ToastProvider>
      </AuthProvider>
    </PayPalScriptProvider>
  );
}

export default App;
